import React, { Component } from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { Controller } from '../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

export class CatsL2 extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Sub-Specialties'
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Specialties', to: '/admin/cats' },
      { title: 'Sub-Specialties' },
    ]
    this.groupId = 'sp'
    this.parentId = this.props.match.params.idl1
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['tags'],
        { groupId: this.groupId, parentId: this.parentId, pb: 'fieldDef' }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['tags', this.parentId]) },
    ]
    this.tableHeadersMap = {
      'Slug / ID': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.slug}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{current.id}</span>
          </div>
        )
      },
      Status: (current) => current.state === 'DISABLED' ? 'DISABLED' : '',
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId,
      parentId: this.parentId
    }
  }

  onFetchSuccess(results) {
    this.pageTitle = 'Sub-Specialities of - ' + results[1].title
    this.formDefinition = results[0].fieldDef
    const fields = []
    for (const field of this.formDefinition.steps[0].fields) {
      if (field.key !== 'parentId') {
        fields.push(field)
      }
    }
    this.formDefinition.steps[0].fields = fields
    results[0].items.forEach(i => i.order = i.title.toLowerCase())
    this.setState({
      items: Helper.sortDictArray(results[0].items),
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['tags']),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['tags', current.id]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['tags', current.id]),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(
      <Link to={'/admin/cats/' + this.parentId + '/' + current.id} key={current.id + '-cats'}>
        <Tooltip title='Product Categories' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons'>subdirectory_arrow_right</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CatsL2.js